export default "__VITE_ASSET__B3YR3Tb1__"